import { render, staticRenderFns } from "./BirthdayManager.vue?vue&type=template&id=80dd16cc&scoped=true&"
import script from "./BirthdayManager.vue?vue&type=script&lang=js&"
export * from "./BirthdayManager.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayManager.vue?vue&type=style&index=0&id=80dd16cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dd16cc",
  null
  
)

export default component.exports